import React from 'react'

//Style
import './BodyWorkFormScreen.css';

//Components
import FormWWU from '../FormWWU/FormWWU'

const BodyWorkFormScreen = () => {
  return (
    <section className='work-with-us-section'>
        <div className="wwu-subcontainer">
            <img src="https://d2bkevvrv5np7q.cloudfront.net/page/crediseguro-page/broker-form-page/wwu-deco-img.webp" alt="" className="wwu-deco-img" loading='lazy' />
            <div className="wwu-form-container">
                <FormWWU />
            </div>
        </div>
    </section>
  )
}

export default BodyWorkFormScreen